import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAllSanitizedReports, addUpdateSanitizedReport } from "../../../core/services/sanitizedReportsService";

interface SanitizedReport {
  id: number;
  reportId: number;
  reportName: string;
  farmId: number;
  submittedAt: string;
  // ...other fields as needed
}

interface SanitizedReportsState {
  reports: SanitizedReport[];
  loading: boolean;
  error: string | null;
}

export const fetchAllSanitizedReports = createAsyncThunk<SanitizedReport[], void, { rejectValue: string }>(
  "sanitizedReports/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      return await getAllSanitizedReports();
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const addOrUpdateSanitizedReport = createAsyncThunk<any, any, { rejectValue: string }>(
  "sanitizedReports/addOrUpdate",
  async (payload, { rejectWithValue }) => {
    try {
      await addUpdateSanitizedReport(payload);
      return payload;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const initialState: SanitizedReportsState = {
  reports: [],
  loading: false,
  error: null,
};

const sanitizedReportsSlice = createSlice({
  name: "sanitizedReports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSanitizedReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllSanitizedReports.fulfilled, (state, action: PayloadAction<SanitizedReport[]>) => {
        state.loading = false;
        state.reports = action.payload;
      })
      .addCase(fetchAllSanitizedReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || null;
      })
      .addCase(addOrUpdateSanitizedReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOrUpdateSanitizedReport.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addOrUpdateSanitizedReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || null;
      });
  },
});

export default sanitizedReportsSlice.reducer; 